import React, { useEffect, useState } from 'react';
import '../PRO/Dialysis/addMachine.css';
import AddPhysioSchedulePopup from './AddPhysioSchedulePopup';
import axios from "axios";
import { APIURL } from "../../Global";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import { useAlert } from 'react-alert';
import ConsultationFees from './ConsultationFees';

const PhysioSchedule = () => {
    const [physioSchedule, setPhysioSchedule] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const [showFees, setShowFees] = useState(false)
    const alert = useAlert()

    useEffect(() => {
        scheduledPhysios()
    }, [])

    const scheduledPhysios = async (currentPage) => {

        const tokenString = sessionStorage.getItem("usertoken");
        let str = tokenString.replace(/["]+/g, "");

        axios
            .get(`${APIURL}/api/v1/service-provider/allied-schedule/`, {
                headers: {
                    Authorization: "Token " + str,
                },
            })
            .then((res) => {
                if (res.status === 200) {
                    const filteredData = res.data.message.filter(item => item.slots.length > 0);
                    setPhysioSchedule(filteredData);
                }
            })

            .catch((err) => { });
    }
    const handleDeleteSlot = (id, slotId) => {
        const tokenString = sessionStorage.getItem("usertoken");
        let str = tokenString.replace(/["]+/g, "");
        const data = {
            slot: slotId
        };

        axios
            .put(`${APIURL}/api/v1/service-provider/allied-schedule-detail/?schedule_id=${id}`, data, {
                headers: {
                    Authorization: "Token " + str,
                },
            })
            .then((res) => {
                if (res.status === 200) {
                    alert.success("Updated successfully")
                    scheduledPhysios();
                }
            })
            .catch((err) => {
                console.error(err);
            });
    };

    const AddSchedulePopUp = (props) => {
        return (
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}
            >
                <Modal.Body style={{ textAlign: "left" }}>
                    <AddPhysioSchedulePopup close={closePopup} primary={false} reload={handleReload} />
                </Modal.Body>
            </Modal>
        );
    };

    const closePopup = () => {
        setShowModal(false);
    };

    const handleReload = () => {
        scheduledPhysios();
    };

    const convertToAMPM = (time) => {
        let [hours, minutes, seconds] = time.split(':');
        hours = parseInt(hours, 10);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        return `${hours}:${minutes} ${ampm}`;
    };

    return (
        (physioSchedule && physioSchedule.length > 0) ? (
            <div className='addmachine-container'>
                <div className='addmachine-header'>
                    <button className='add-machine-button'style={{marginRight:'5px'}} onClick={() => setShowFees(!showFees)}>Add Consultation Fees</button>
                    <button className='add-machine-button' onClick={() => setShowModal(true)}>Add Schedule</button>
                </div>
                {showFees && <ConsultationFees />}
                <div className=''>
                    {physioSchedule.length > 0 && physioSchedule.map((physio, index) => {
                        const defaultDays = {
                            monday: "False",
                            tuesday: "False",
                            wednesday: "False",
                            thursday: "False",
                            friday: "False",
                            saturday: "False",
                            sunday: "False"
                        };
                        const physioDays = { ...defaultDays, ...physio.days };
                        const fromDate = moment(physio.from_date).format('YYYY-MM-DD');
                        const toDate = moment(physio.to_date).format('YYYY-MM-DD');
                        const fromDay = moment(physio.from_date).format('ddd');
                        const toDay = moment(physio.to_date).format('ddd');
                        return (
                            <div key={physio.id} className='mschedule-card'>
                                <div style={{ flex: 3, alignContent: "center" }}>
                                    <label className='model-name' style={{ textTransform: 'capitalize' }}>{physio.allied_prof}</label>
                                </div>
                                <div className='mschedule-time'>
                                    {physio.slots.map((slot) => (
                                        <div className='mschedule-ti'>
                                            <div style={{ flex: 1, alignContent: "center" }}><svg onClick={() => handleDeleteSlot(physio.id, slot.id)} style={{ cursor: "pointer" }} width="20" height="20" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14.375 7.5H20.625C20.625 6.6712 20.2958 5.87634 19.7097 5.29029C19.1237 4.70424 18.3288 4.375 17.5 4.375C16.6712 4.375 15.8763 4.70424 15.2903 5.29029C14.7042 5.87634 14.375 6.6712 14.375 7.5ZM12.5 7.5C12.5 6.17392 13.0268 4.90215 13.9645 3.96447C14.9021 3.02678 16.1739 2.5 17.5 2.5C18.8261 2.5 20.0979 3.02678 21.0355 3.96447C21.9732 4.90215 22.5 6.17392 22.5 7.5H30.3125C30.5611 7.5 30.7996 7.59877 30.9754 7.77459C31.1512 7.9504 31.25 8.18886 31.25 8.4375C31.25 8.68614 31.1512 8.9246 30.9754 9.10041C30.7996 9.27623 30.5611 9.375 30.3125 9.375H28.675L27.1537 27.6287C27.0431 28.9567 26.4374 30.1945 25.4569 31.0968C24.4763 31.9991 23.1925 32.4999 21.86 32.5H13.14C11.8075 32.4999 10.5237 31.9991 9.54313 31.0968C8.56259 30.1945 7.95693 28.9567 7.84625 27.6287L6.325 9.375H4.6875C4.43886 9.375 4.2004 9.27623 4.02459 9.10041C3.84877 8.9246 3.75 8.68614 3.75 8.4375C3.75 8.18886 3.84877 7.9504 4.02459 7.77459C4.2004 7.59877 4.43886 7.5 4.6875 7.5H12.5ZM9.715 27.4725C9.78649 28.3318 10.1783 29.1328 10.8127 29.7167C11.4471 30.3006 12.2778 30.6248 13.14 30.625H21.86C22.7222 30.6248 23.5529 30.3006 24.1873 29.7167C24.8217 29.1328 25.2135 28.3318 25.285 27.4725L26.795 9.375H8.20625L9.715 27.4725ZM14.6875 13.75C14.9361 13.75 15.1746 13.8488 15.3504 14.0246C15.5262 14.2004 15.625 14.4389 15.625 14.6875V25.3125C15.625 25.5611 15.5262 25.7996 15.3504 25.9754C15.1746 26.1512 14.9361 26.25 14.6875 26.25C14.4389 26.25 14.2004 26.1512 14.0246 25.9754C13.8488 25.7996 13.75 25.5611 13.75 25.3125V14.6875C13.75 14.4389 13.8488 14.2004 14.0246 14.0246C14.2004 13.8488 14.4389 13.75 14.6875 13.75ZM21.25 14.6875C21.25 14.4389 21.1512 14.2004 20.9754 14.0246C20.7996 13.8488 20.5611 13.75 20.3125 13.75C20.0639 13.75 19.8254 13.8488 19.6496 14.0246C19.4738 14.2004 19.375 14.4389 19.375 14.6875V25.3125C19.375 25.5611 19.4738 25.7996 19.6496 25.9754C19.8254 26.1512 20.0639 26.25 20.3125 26.25C20.5611 26.25 20.7996 26.1512 20.9754 25.9754C21.1512 25.7996 21.25 25.5611 21.25 25.3125V14.6875Z" fill="#104D86" />
                                            </svg>
                                            </div>
                                            <div style={{ flex: 6, alignContent: "center" }}>{convertToAMPM(slot.from_time)} &nbsp; - &nbsp; {convertToAMPM(slot.to_time)}</div>
                                            <div style={{ flex: 3, alignContent: "center" }}><label className=''>{slot.token}{slot.token === 1 ? "Token" : "Tokens"}</label></div>
                                        </div>
                                    ))}
                                </div>
                                <div className='mschedule-dayview-container'>
                                    <div style={{ display: "flex", flex: 3 }}>
                                        {daysOfWeek.map((day) => (
                                            <div
                                                key={day}
                                                className={`day-view ${physioDays[day.toLowerCase()] === "True" || physioDays[day.toLowerCase()] === "true" ? 'green' : 'grey'}`}
                                            >
                                                <span>{day[0]}</span>
                                            </div>
                                        ))}
                                    </div>
                                    <div className='mschedule-date'>
                                        <div>{`${fromDay}, ${moment(physio.from_date).format('DD MMMM YYYY')} -  ${toDay}, ${moment(physio.to_date).format('DD MMMM YYYY')}`}</div>
                                    </div>
                                    {/* <div className='mschedule-view-icons'>
                                        <svg width="25" height="25" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.375 7.5H20.625C20.625 6.6712 20.2958 5.87634 19.7097 5.29029C19.1237 4.70424 18.3288 4.375 17.5 4.375C16.6712 4.375 15.8763 4.70424 15.2903 5.29029C14.7042 5.87634 14.375 6.6712 14.375 7.5ZM12.5 7.5C12.5 6.17392 13.0268 4.90215 13.9645 3.96447C14.9021 3.02678 16.1739 2.5 17.5 2.5C18.8261 2.5 20.0979 3.02678 21.0355 3.96447C21.9732 4.90215 22.5 6.17392 22.5 7.5H30.3125C30.5611 7.5 30.7996 7.59877 30.9754 7.77459C31.1512 7.9504 31.25 8.18886 31.25 8.4375C31.25 8.68614 31.1512 8.9246 30.9754 9.10041C30.7996 9.27623 30.5611 9.375 30.3125 9.375H28.675L27.1537 27.6287C27.0431 28.9567 26.4374 30.1945 25.4569 31.0968C24.4763 31.9991 23.1925 32.4999 21.86 32.5H13.14C11.8075 32.4999 10.5237 31.9991 9.54313 31.0968C8.56259 30.1945 7.95693 28.9567 7.84625 27.6287L6.325 9.375H4.6875C4.43886 9.375 4.2004 9.27623 4.02459 9.10041C3.84877 8.9246 3.75 8.68614 3.75 8.4375C3.75 8.18886 3.84877 7.9504 4.02459 7.77459C4.2004 7.59877 4.43886 7.5 4.6875 7.5H12.5ZM9.715 27.4725C9.78649 28.3318 10.1783 29.1328 10.8127 29.7167C11.4471 30.3006 12.2778 30.6248 13.14 30.625H21.86C22.7222 30.6248 23.5529 30.3006 24.1873 29.7167C24.8217 29.1328 25.2135 28.3318 25.285 27.4725L26.795 9.375H8.20625L9.715 27.4725ZM14.6875 13.75C14.9361 13.75 15.1746 13.8488 15.3504 14.0246C15.5262 14.2004 15.625 14.4389 15.625 14.6875V25.3125C15.625 25.5611 15.5262 25.7996 15.3504 25.9754C15.1746 26.1512 14.9361 26.25 14.6875 26.25C14.4389 26.25 14.2004 26.1512 14.0246 25.9754C13.8488 25.7996 13.75 25.5611 13.75 25.3125V14.6875C13.75 14.4389 13.8488 14.2004 14.0246 14.0246C14.2004 13.8488 14.4389 13.75 14.6875 13.75ZM21.25 14.6875C21.25 14.4389 21.1512 14.2004 20.9754 14.0246C20.7996 13.8488 20.5611 13.75 20.3125 13.75C20.0639 13.75 19.8254 13.8488 19.6496 14.0246C19.4738 14.2004 19.375 14.4389 19.375 14.6875V25.3125C19.375 25.5611 19.4738 25.7996 19.6496 25.9754C19.8254 26.1512 20.0639 26.25 20.3125 26.25C20.5611 26.25 20.7996 26.1512 20.9754 25.9754C21.1512 25.7996 21.25 25.5611 21.25 25.3125V14.6875Z" fill="#104D86" />
                                        </svg>
                                        &nbsp;&nbsp;
                                    </div> */}
                                </div>
                            </div>
                        )
                    }
                    )}
                </div>{
                    showModal &&
                    < AddSchedulePopUp
                        show={showModal}
                        onHide={() => {
                            setShowModal(false);
                        }}
                    />}
            </div>
        ) : (
            <div className='mschedule-primary-container'>
                <AddPhysioSchedulePopup primary={true} reload={handleReload} />
            </div>
        )
    );
};

export default PhysioSchedule;
